import { API } from "../../../config";
import CONSTANTS from "../../../constants/constants";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { serverAPIPath ,mockAPIPath} from "../config/apiPath";


class PasswordService {

    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read() };
    }

    async verify() {
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ?
            await new AxiosUtils(mockAPIPath.VERIFY_PASSWORD, this.payload).getNew() : 
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.VERIFY_PASSWORD}`, this.payload, this.headers).post();
        let isPasswordVerified: string;
        if(response?.data?.success==true) {
            isPasswordVerified = response?.data?.message;
            return isPasswordVerified;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }

    async update() {
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ?
            await new AxiosUtils(mockAPIPath.UPDATE_PASSWORD, this.payload).getNew() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.UPDATE_PASSWORD}`, this.payload, this.headers).put();
        let isPasswordUpdated: string;
        if(response?.data?.success==true) {
            isPasswordUpdated = response?.data?.message;
            return isPasswordUpdated;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }

    async reset(isDemoUser?:boolean) {
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ?
            await new AxiosUtils(mockAPIPath.RESET_PASSWORD, this.payload).getNew() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.RESET_PASSWORD}`, this.payload,{"demo-user": isDemoUser ?  CONSTANTS.DEMO_USER_CONSTANTS : "" }).put();
        let isPasswordReseted: string;
        if(response?.data?.success==true) {
            isPasswordReseted = response?.data?.message;
            return isPasswordReseted;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }
    async demoUserSetPassword(){
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ?
            await new AxiosUtils(mockAPIPath.RESET_PASSWORD, this.payload).getNew() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.DEMO_USER_SET_PASSWORD}`, this.payload,{ "demo-user": "1" }).post();
        let isPasswordReseted: string;
        console.log(response, "response ++++");
        if(response?.data?.success==true) {
            isPasswordReseted = response?.data?.message;
            const userEmail = response?.data?.data?.userEmail;
            return {
                isPasswordReseted,
                userEmail
            };
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }
}

export default PasswordService;